import {useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {ContextAppState} from "@app/context.ts";
import {backButton} from "@telegram-apps/sdk-react";

export const useTelegramShowBackButton = () => {
    const appState = useContext(ContextAppState);
    const navigate = useNavigate();

    useEffect(() => {
        if (appState.type === "Telegram") {
            if (backButton.show.isAvailable()) {
                if (backButton.onClick.isAvailable()) {
                    const off = backButton.onClick(() => {
                        navigate(-1);
                        off();
                    });
                }
                backButton.show();
            }
        }
    }, [appState.type, navigate]);
}

export const useTelegramHideBackButton = () => {
    const appState = useContext(ContextAppState);
    useEffect(() => {
        if (appState.type === "Telegram") {
            if (backButton.hide.isAvailable()) {
                backButton.hide();
            }
        }
    }, [appState.type]);
}